import script from "./Empower.vue?vue&type=script&setup=true&lang=ts"
export * from "./Empower.vue?vue&type=script&setup=true&lang=ts"

import "./Empower.vue?vue&type=style&index=0&id=d4022216&scoped=true&lang=less"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d4022216"]])

export default __exports__